import { createContext, useContext } from "react";
import classnames from "classnames";

export const BrandContext = createContext({});

export const useBrandStyleClasses =
  () =>
  (defaultStyles, { simple, elegant, brutalist, playful }) => {
    const { isPlayful, isElegant, isSimple, isBrutalist } =
      useContext(BrandContext);

    return classnames(defaultStyles, {
      [`simple ${simple}`]: isSimple,
      [`elegant ${elegant}`]: isElegant,
      [`playful ${playful}`]: isPlayful,
      [`brutalist ${brutalist}`]: isBrutalist,
    });
  };
